import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IGetCarousel } from '../models/carousel.model';
import { Observable } from 'rxjs';
import { IGetRecomendationsResponse } from '../models/recomendations.model';

@Injectable({
  providedIn: 'root'
})
export class CarouselService {

  private URL: string = environment.rootUrl;
  private URL_LAMBDA: string = environment.lambdaUrl;

  private defaultStore = environment.defaultStore;

  constructor(
    private http: HttpClient
  ) { }

  public getCarousels(branch_id: any): Promise<any> {
    return this.http.get(`${this.URL}/carrousels/${branch_id ?? this.defaultStore}`).toPromise();
  }

  public getCarousel(branch_id: any, carousel_id: any, page: number, limit: number, subcategorias: string, categorias: string, marcas: string, order: string, order_type = ''): Promise<any> {
    let params = new HttpParams();
    if (subcategorias !== '') {
      params = params.set('subcategoria', subcategorias);
    }
    if (categorias !== '') {
      params = params.set('categoria', categorias);
    }
    if (marcas !== '') {
      params = params.set('marca', marcas);
    }
    return this.http.get<IGetCarousel>(`${this.URL}/carrousels/${branch_id ?? this.defaultStore}/${carousel_id}?page=${page}&limit=${limit}&orden=${order}&orden_type=${order_type}`, { params }).toPromise();
  }

  public getSuggestedCarousel(branch: number, checkout: boolean, page = 1): Observable<IGetRecomendationsResponse> {
    return this.http.get<IGetRecomendationsResponse>(`${this.URL_LAMBDA}/recomendations?branch=${branch}&page=${page}&checkout=${checkout}`);
  }
}
